// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_EMA","cls2":"UpsellModalRedesign-cls2__q4 UpsellModalRedesign-cls1_EMA"};